import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import { getErrorMessage } from "../../../helpers/functions";
import { useSnackbar } from "notistack";
import { Button } from "@material-ui/core";
import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import AccordionDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AddDocBundleDrawer from "./AddDocumentBundle";
import useNotification from "../../../hooks/useNotification";
import { Tooltip } from "@material-ui/core";
import useLoader from "../../../hooks/useLoader";
import DeleteIcons from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import EditBundleName from "./EditBundleName";
import AlertDialog from "../../common/Alert";
import useBundle from "../../../hooks/useBundle";
import {
  PostAddRounded,
  EventNote,
  LibraryAddRounded,
  RemoveCircleOutline,
  Description,
  LibraryBooks,
} from "@material-ui/icons";
import HearingBundleShared from "../HearingBundleShared";
import Annotation from "./Annotation";
import HttpsIcon from "@material-ui/icons/Https";
import PublicIcon from "@material-ui/icons/Public";
import HttpsLockOpen from "@material-ui/icons/LockOpen";
import BundleService from "../../../services/BundleService";
import BundleAddPages from "../../common/CustomBundle/index";
import BundleDeletePages from "../../common/CustomBundle/DeletePage";
import AddPages from "../../common/CustomBundle/AddPages";
import PdfViewer from "./PdfViewer";

const Index = ({
  id,
  setRefreshDetails,
  refreshDetails,
  success,
  setSuccess,
  documents,
  viewOnly,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [bundleName, setBundleName] = useState();
  const caseId = id;
  const { triggerNotify, setTriggerNotify } = useNotification();
  const { bundleOpen } = useBundle();

  useEffect(() => {
    if (triggerNotify) {
      setRefreshDetails(true);
      setTriggerNotify(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerNotify]);

  useEffect(() => {
    async function getBundleName() {
      try {
        const response_data = await BundleService.getBundleName(caseId);
        if (response_data) {
          if (bundleOpen?.boolean === true && success) {
            const updatedArray = [
              ...response_data?.bundleDetails.slice(0, -1),
              {
                ...response_data?.bundleDetails[
                  response_data?.bundleDetails.length - 1
                ],
                newKey: bundleOpen?.boolean,
              },
            ];
            setBundleName(updatedArray);
          } else {
            setBundleName(response_data?.bundleDetails);
          }
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, { variant: "error" });
      } finally {
        setSuccess(false);
      }
    }
    if (refreshDetails) {
      setRefreshDetails(false);
    } else if (bundleOpen) {
      getBundleName(bundleOpen);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshDetails, bundleOpen]);

  return (
    <Table
      {...{
        caseId,
        bundleName,
        setRefreshDetails,
        refreshDetails,
        documents,
        viewOnly,
      }}
      boolean={bundleOpen?.boolean}
    />
  );
};

export default Index;

const Table = ({
  caseId,
  bundleName,
  setRefreshDetails,
  refreshDetails,
  boolean,
  documents,
  viewOnly,
}) => {
  return (
    <TableContainer>
      {bundleName
        ? bundleName.map((item, index) => (
            <TableWithAccordion
              key={index}
              title={item?.bundleName}
              id={item?.id}
              caseId={caseId}
              bundleDocs={item?.bundleDocuments}
              setRefreshDetails={setRefreshDetails}
              refreshDetails={refreshDetails}
              bundleCode={item?.bundleCode}
              visibilityType={item?.visibilityType}
              self={item?.self}
              newKey={item?.newKey}
              boolean={boolean}
              documents={documents}
              pageNoFlag={item?.pageNoFlag}
              tableofContentsFlag={item?.tableofContentsFlag}
              viewOnly={viewOnly}
            />
          ))
        : ""}
    </TableContainer>
  );
};

function TableWithAccordion({
  id,
  title,
  bundleDocs,
  caseId,
  refreshDetails,
  setRefreshDetails,
  bundleCode,
  self,
  boolean,
  newKey,
  documents,
  visibilityType,
  pageNoFlag,
  tableofContentsFlag,
  viewOnly,
}) {
  const [openBundleModal, setOpenBundleModal] = useState(false);
  const [docName, setDocName] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [expanded, setExpanded] = useState(false);
  const { setLoader } = useLoader();
  const [editBundle, setEditBundle] = useState(false);
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState({});
  const [modal, setModal] = useState(false);
  const [annotation, setAnnotation] = useState(false);
  const [addpage, setAddpage] = useState(false);
  const [delpage, setDelpage] = useState(false);
  const [add, setAdd] = useState(false);

  useEffect(() => {
    async function getBundleName() {
      try {
        const response_data = await BundleService.getDocumentList(caseId, id);
        if (response_data) {
          setDocName(response_data?.documentList);
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, { variant: "error" });
      }
    }
    getBundleName();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (newKey && documents && docName?.length) {
      setTimeout(() => {
        setOpenBundleModal(boolean);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newKey, documents, docName?.length]);

  const customBundleDelete = async (id) => {
    try {
      setLoader({ state: true, message: "Deleting bundle..." });
      const res = await BundleService.customBundleDelete(id);
      if (res?.message) {
        enqueueSnackbar(res?.message, { variant: "success" });
      }
      setRefreshDetails(true);
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, { variant: "error" });
    } finally {
      setLoader({ state: false });
      setOpen(false);
    }
  };

  const openConfirmDelete = (id) => {
    setOpen(true);
    setDialogData({
      primaryBtnText: "Cancel",
      secondaryBtnText: "OK",
      clickSecondarybtn: () => customBundleDelete(id),
      clickPrimaryBtn: () => setOpen(false),
      onDialogClose: () => setOpen(false),
      desc: `Are you sure you want to delete this bundle?`,
      heading: "Delete Bundle",
      descriptionTextStyle: {
        textAlign: "center",
        fontFamily: theme.fonts.primaryFontSemiBold,
      },
    });
  };

  const isActionDisabled =
    !bundleDocs || pageNoFlag || tableofContentsFlag || !self;

  const actions = [
    {
      text: "Add Page Number & TOC",
      props: { onClick: () => addPageNumberBundle(id) },
      disabled: isActionDisabled,
      icon: (
        <PostAddRounded
          style={{ fill: isActionDisabled ? "#8294a5" : "#00838c" }}
        />
      ),
      tooltip: "Add Page Number & TOC",
    },
    {
      text: bundleDocs?.length ? "Regenerate Document" : "Generate Document",
      props: {
        onClick: () => setOpenBundleModal(true),
      },
      disabled: docName?.length && self ? false : true,
      icon: (
        <Description
          style={{ fill: docName?.length && self ? "#00838c" : "#8294a5" }}
        />
      ),
      tooltip: bundleDocs?.length ? "Regenerate Document" : "Generate Document",
    },
    {
      text: "Edit Bundle Name",
      props: { onClick: () => setEditBundle(true) },
      disabled: !self,
      icon: <EditIcon style={{ fill: self ? COLORS.COLOR_DARK : "#8294a5" }} />,
      tooltip: "Edit Bundle Name",
    },
    {
      text: "Annotation",
      props: { onClick: () => setAnnotation(true) },
      disabled: !(bundleDocs && self),
      icon: (
        <EventNote
          style={{ fill: self && bundleDocs ? COLORS.COLOR_DARK : "#8294a5" }}
        />
      ),
      tooltip: "Annotation",
    },
    {
      text: "Add Section",
      props: { onClick: () => setAddpage(true) },
      disabled: isActionDisabled,
      icon: (
        <LibraryAddRounded
          style={{ fill: isActionDisabled ? "#8294a5" : COLORS.COLOR_DARK }}
        />
      ),
      tooltip: "Add Section",
    },
    {
      text: "Delete pages",
      props: { onClick: () => setDelpage(true) },
      disabled: isActionDisabled,
      icon: (
        <RemoveCircleOutline
          style={{ fill: isActionDisabled ? "#8294a5" : COLORS.LOGOUT_RED }}
        />
      ),
      tooltip: "Delete pages",
    },
    {
      text: "Delete",
      props: { onClick: () => openConfirmDelete(id) },
      disabled: !self,
      icon: (
        <DeleteIcons style={{ fill: self ? COLORS.LOGOUT_RED : "#8294a5" }} />
      ),
      tooltip: "Delete Bundle",
    },
    {
      text: "Add page",
      props: { onClick: () => setAdd(true) },
      disabled: isActionDisabled,
      icon: (
        <LibraryBooks
          style={{ fill: isActionDisabled ? "#8294a5" : "#00838c" }}
        />
      ),
      tooltip: "Add page",
    },
    {
      text: "Visibility",
      props: { onClick: () => setModal(true) },
      disabled: !self,
      icon:
        visibilityType === "all" ? (
          <PublicIcon style={{ fill: self ? "#00838c" : "#8294a5" }} />
        ) : visibilityType === "others" ? (
          <HttpsLockOpen style={{ fill: self ? "#00838c" : "#8294a5" }} />
        ) : (
          <HttpsIcon style={{ fill: self ? "#00838c" : "#8294a5" }} />
        ),
      tooltip:
        visibilityType === "all"
          ? "Public"
          : visibilityType === "others"
            ? "Share With CM and Neutral"
            : "Private",
    },
  ];

  const addPageNumberBundle = async (id) => {
    try {
      setLoader({ state: true, message: "Adding page numbers..." });
      const res = await BundleService.addPageNumberBundle(id);
      if (res?.message) {
        enqueueSnackbar(res?.message, { variant: "success" });
      }
      setRefreshDetails(true);
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, { variant: "error" });
    } finally {
      setLoader({ state: false });
    }
  };

  const validPdfUrls = bundleDocs?.length
    ? bundleDocs
        .map((item) => item?.url?.url)
        .filter((u) => typeof u === "string" && u.endsWith(".pdf"))
    : [];

  return (
    <>
      <AccordionWrapper>
        <StyledAccordion expanded={expanded}>
          <StyledAccordionSummary
            expandIcon={
              <ExpandIconWrapper
                expanded={expanded}
                onClick={(e) => {
                  e.stopPropagation();
                  setExpanded((e) => !e);
                }}
              >
                <ExpandMoreIcon />
              </ExpandIconWrapper>
            }
            aria-controls="panel1a-content"
            id="panel1a-header"
            onClick={() => setExpanded((e) => !e)}
          >
            <BundleHeader>
              <BundleIconWrap>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" />
                </svg>
              </BundleIconWrap>
              <BundleTitleWrap>
                <BundleTitle>
                  {bundleCode ? `${bundleCode} — ${title}` : title}
                </BundleTitle>
                {bundleDocs && (
                  <DocCountBadge>
                    {bundleDocs.length} doc{bundleDocs.length !== 1 ? "s" : ""}
                  </DocCountBadge>
                )}
              </BundleTitleWrap>
            </BundleHeader>

            {validPdfUrls.length > 0 && (
              <PdfViewerWrap onClick={(e) => e.stopPropagation()}>
                <PdfViewer
                  urls={validPdfUrls}
                  bundleCode={`${bundleCode} - ${title}`}
                />
              </PdfViewerWrap>
            )}
          </StyledAccordionSummary>

          <StyledAccordionDetails>
            <DocumentList>
              {bundleDocs?.length ? (
                bundleDocs.map((data, index) => (
                  <DocumentItem key={index}>
                    <DocumentLink onClick={() => window.open(data?.url?.url)}>
                      <DocFileIcon>
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                        </svg>
                      </DocFileIcon>
                      <DocumentName>
                        {typeof data?.url?.url === "string" &&
                        data.url.url.includes("/")
                          ? decodeURI(data.url.url.split("/").pop())
                          : "-"}
                      </DocumentName>
                      <ExternalIcon>
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                        >
                          <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
                          <polyline points="15 3 21 3 21 9" />
                          <line x1="10" y1="14" x2="21" y2="3" />
                        </svg>
                      </ExternalIcon>
                    </DocumentLink>
                  </DocumentItem>
                ))
              ) : (
                <EmptyDocs>No documents in this bundle</EmptyDocs>
              )}
            </DocumentList>
          </StyledAccordionDetails>

          {viewOnly !== true && (
            <ActionsBar>
              <ActionButtonGroup>
                {actions.map((action, index) => (
                  <Tooltip key={index} title={action.tooltip} placement="top">
                    <span>
                      <ActionButton
                        {...action.props}
                        disabled={action.disabled}
                      >
                        <IconWrapper disabled={action.disabled}>
                          {action.icon}
                        </IconWrapper>
                      </ActionButton>
                    </span>
                  </Tooltip>
                ))}
              </ActionButtonGroup>
            </ActionsBar>
          )}
        </StyledAccordion>
      </AccordionWrapper>

      <AddDocBundleDrawer
        id={id}
        caseId={caseId}
        bundleName={title}
        docName={docName}
        bundleDocs={bundleDocs}
        {...{
          openBundleModal,
          setOpenBundleModal,
          setRefreshDetails,
          refreshDetails,
          setDocName,
        }}
        heading="Enter Bundle Name"
        btnText="Enter Bundle Name"
      />
      <HearingBundleShared
        {...{ id, caseId, modal, setModal, visibilityType, setRefreshDetails }}
      />
      <EditBundleName
        {...{ id, caseId, editBundle, setEditBundle, title, setRefreshDetails }}
      />
      <Annotation {...{ id, caseId, annotation, setAnnotation }} />
      <BundleAddPages
        {...{
          id,
          addpage,
          setAddpage,
          caseId,
          docName,
          bundleDocs,
          title,
          setRefreshDetails,
        }}
      />
      <BundleDeletePages {...{ id, delpage, setDelpage, setRefreshDetails }} />
      <AddPages
        {...{
          id,
          add,
          setAdd,
          setRefreshDetails,
          caseId,
          docName,
          bundleDocs,
          title,
        }}
      />
      <AlertDialog
        isOpen={open}
        {...{ ...dialogData }}
        descriptionTextStyle={{
          textAlign: "center",
          fontFamily: theme.fonts.primaryFontSemiBold,
        }}
      />
    </>
  );
}

const TableContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const AccordionWrapper = styled.div`
  padding: 0 14px;

  @media ${theme?.breakpoints?.sm_up} {
    padding: 0 20px;
  }
`;

const StyledAccordion = styled(Accordion)`
  width: 100% !important;
  background: #ffffff !important;
  border: 1.5px solid #e2e8f0 !important;
  border-radius: 16px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
  margin: 0 !important;
  overflow: hidden !important;

  &:hover {
    border-color: #b2e8eb !important;
    box-shadow: 0 6px 20px rgba(0, 131, 140, 0.1) !important;
  }

  &.Mui-expanded {
    margin: 0 !important;
    border-color: #00838c !important;
    box-shadow: 0 8px 24px rgba(0, 131, 140, 0.14) !important;
  }

  & .MuiIconButton-root {
    padding: 8px !important;
    margin-right: 0 !important;
  }

  & .MuiSvgIcon-root {
    fill: #00838c;
  }
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  cursor: pointer !important;
  padding: 0 16px !important;
  min-height: 68px !important;
  transition: background-color 0.2s ease !important;

  &:hover {
    background: #f8fafc !important;
  }

  & .MuiAccordionSummary-content {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    width: 100% !important;
    margin: 16px 0 !important;
    gap: 12px !important;
    flex-wrap: wrap !important;
  }

  @media (max-width: 600px) {
    padding: 0 12px !important;
    min-height: 60px !important;
  }
`;

const BundleHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

const BundleIconWrap = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #e6f7f8 0%, #b2e8eb 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #00838c;

  @media (max-width: 400px) {
    display: none;
  }
`;

const BundleTitleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-wrap: wrap;
`;

const BundleTitle = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 15px;
  color: #293461;
  letter-spacing: 0.2px;
  word-break: break-word;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

const DocCountBadge = styled.span`
  font-size: 11px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: #fff;
  background: #00838c;
  padding: 2px 9px;
  border-radius: 100px;
  white-space: nowrap;
  flex-shrink: 0;
`;

const PdfViewerWrap = styled.div`
  display: flex;
  align-items: center;
`;

const ExpandIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #f0fdfb;
  border: 1.5px solid #99f6e4;
  cursor: pointer;
  transition: all 0.3s ease;
  transform: ${({ expanded }) =>
    expanded ? "rotate(180deg)" : "rotate(0deg)"};

  & svg {
    color: #00838c;
    font-size: 20px;
  }

  &:hover {
    & svg {
      color: #fff;
    }
  }
`;

const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 0 !important;
  background: #fafcff !important;
  border-top: 1.5px solid #e2e8f0 !important;
`;

const DocumentList = styled.div`
  width: 100%;
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  @media (max-width: 480px) {
    padding: 12px 14px;
  }
`;

const DocumentItem = styled.div`
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.2s ease;
`;

const DocumentLink = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  cursor: pointer;
  border-radius: 10px;
  border: 1.5px solid transparent;
  transition: all 0.2s ease;
  background: #ffffff;

  &:hover {
    border-color: #99f6e4;
    background: linear-gradient(135deg, #f0fdfb 0%, #e6f7f8 100%);
    transform: translateX(4px);
  }
`;

const DocFileIcon = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #f0fdfb;
  border: 1.5px solid #99f6e4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #00838c;
`;

const DocumentName = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 13px;
  color: #00838c;
  text-decoration: underline;
  word-break: break-all;
  flex: 1;
  transition: color 0.2s;

  ${DocumentLink}:hover & {
    color: #006b73;
  }
`;

const ExternalIcon = styled.div`
  color: #94a3b8;
  display: flex;
  flex-shrink: 0;
  transition: color 0.2s;

  ${DocumentLink}:hover & {
    color: #00838c;
  }
`;

const EmptyDocs = styled.p`
  font-size: 13px;
  color: #94a3b8;
  font-family: ${theme.fonts.primaryFontRegular};
  text-align: center;
  padding: 16px 0;
  margin: 0;
`;

/* ── Actions Bar ── */
const ActionsBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 18px;
  border-top: 1.5px solid #e2e8f0;
  background: #f8fafc;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 480px) {
    padding: 10px 12px;
    justify-content: center;
  }
`;

const ActionButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;

  @media (max-width: 480px) {
    justify-content: center;
  }
`;

const ActionButton = styled(Button)`
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
  padding: 0 !important;
  border: 1.5px solid #e2e8f0 !important;
  background-color: #fff !important;
  border-radius: 10px !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  ${({ disabled }) =>
    disabled
      ? css`
          cursor: not-allowed !important;
          opacity: 0.45 !important;
        `
      : css`
          &:hover {
            background: linear-gradient(
              135deg,
              #f0fdfb 0%,
              #e6f7f8 100%
            ) !important;
            border-color: #00838c !important;
            box-shadow: 0 4px 12px rgba(0, 131, 140, 0.18) !important;
            transform: translateY(-2px) !important;
          }
          &:active {
            transform: translateY(0) !important;
          }
        `}
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & svg {
    font-size: 18px;
  }
`;
